<template>
  <div id="home">
    <b-container>
      <b-row>
        <b-col>
          <p>
            Perivoli's aim is to transform the prospects of children aged two to
            six in poor communities across Sub-Saharan Africa by helping nursery
            school teachers release the full potential of the children at their
            schools.
          </p>
          <p>
            This database stores programme data for their programmes in Namibia, Malawi and Zambia
            and can only be accessed only by authorised Perivoli staff. If you
            are looking for more information about Perivoli and their
            programmes, please refer to their website:
            <a
              href="http://www.perivolischools.com/"
              class="site-link"
            >www.perivolischools.com</a>.
          </p>
          <p>
            If you are an authorised staff member, please login using the link
            at the top right of the screen.
          </p>
          <!-- <b-button
            :size="'lg'"
            :variant="'primary'"
            class="app_school_btn mb-4"
            @click.prevent="downloadAPK"
            v-show="isLoggedIn"
          >-->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "home",
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn"
    })
  }
};
</script>
